export class LoginWithTokenAction {
  static type = '[USER] Login with Token';

  constructor(readonly token: string) {}
}
